export class Locality {
    localityCode: string="";
    localityDesc: string="";
}